<ng-container *ngIf="active; else statusTemplate">
    <button
        mat-icon-button
        class="primary"
        matTooltipPosition="above"
        [disabled]="disabled"
        [matTooltip]="tooltip"
        (click)="onButtonClick()"
    >
        <mat-icon>{{ icon }}</mat-icon>
    </button>
</ng-container>
<ng-template #statusTemplate>
    <ng-container [ngSwitch]="currentStatus">
        <button
            *ngSwitchCase="statuses.FOCUS"
            mat-icon-button
            class="primary"
            matTooltipPosition="above"
            [disabled]="disabled"
            [matTooltip]="tooltip"
            (click)="onButtonClick()"
        >
            <mat-icon class="material-icons-outlined">{{ icon }}</mat-icon>
        </button>
        <button
            *ngSwitchCase="statuses.DEFAULT"
            mat-icon-button
            matTooltipPosition="above"
            [disabled]="disabled"
            [matTooltip]="tooltip"
            (click)="onButtonClick()"
        >
            <mat-icon class="material-icons-outlined">{{ icon }}</mat-icon>
        </button>
    </ng-container>
</ng-template>
